import { useEffect, useState } from "react";
import axios from "axios";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const faqs = [
  {
    q: "Bagaimana cara membeli produknya?",
    a: "Sangat mudah. Klik tombol pada produk pilihan Anda, dan Anda akan diarahkan ke halaman checkout resmi platform. Selesaikan pembayaran di sana — prosesnya hanya beberapa menit.",
  },
  {
    q: "Apakah pembayaran saya aman?",
    a: "Ya. Semua transaksi diproses langsung oleh payment gateway resmi platform penyedia produk. Kami tidak pernah meminta atau menyimpan data kartu Anda.",
  },
  {
    q: "Kapan saya mendapatkan akses produk?",
    a: "Umumnya akses diberikan segera setelah pembayaran terkonfirmasi oleh platform. Instruksi akses akan dikirim melalui email atau akun platform Anda.",
  },
  {
    q: "Apakah produk ini cocok untuk pemula?",
    a: "Sangat cocok. Program dalam katalog ini dirancang berjenjang — mulai dari fondasi pola pikir hingga penerapan praktis — sehingga bisa diikuti tanpa pengalaman sebelumnya.",
  },
  {
    q: "Kenapa membeli melalui halaman ini?",
    a: "Kami adalah mitra affiliate resmi. Harga yang Anda bayar sama dengan harga resmi, namun Anda mendapat panduan kurasi dan dukungan dari kami dalam memilih program yang paling sesuai.",
  },
];

export const SocialProof = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    axios.get(`${API}/testimonials`).then((res) => setTestimonials(res.data)).catch(() => setTestimonials([]));
  }, []);

  return (
  <>
    <section id="testimoni" className="py-24 md:py-32 bg-[#F3ECDC] border-y border-[#211B10]/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#A67C1E] mb-6">Kata Mereka</p>
          <h2 className="font-display tracking-tighter text-3xl md:text-5xl max-w-2xl leading-tight mb-20">
            Perubahan nyata dari orang-orang yang berani memulai.
          </h2>
        </Reveal>
        <div className="grid md:grid-cols-2 gap-10 md:gap-16">
          {testimonials.map((t, i) => (
            <Reveal key={t.testimonial_id} delay={i * 0.15} className={i % 2 === 1 ? "md:mt-16" : ""}>
              <figure data-testid={`testimonial-${i}`} className="border border-[#211B10]/10 bg-white p-10">
                <blockquote className="font-display text-xl md:text-2xl leading-relaxed tracking-tight text-[#211B10]/90 mb-10">
                  “{t.quote}”
                </blockquote>
                <figcaption className="flex items-center gap-4">
                  {t.image_url && (
                    <img src={t.image_url} alt={t.name} className="w-12 h-12 object-cover grayscale border border-[#211B10]/20" />
                  )}
                  <div>
                    <p className="text-sm font-medium">{t.name}</p>
                    <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#211B10]/60">{t.role}</p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>

    <section id="faq" className="py-24 md:py-32 bg-[#FBF7EE]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-12">
        <Reveal className="md:col-span-5">
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-[#A67C1E] mb-6">FAQ</p>
          <h2 className="font-display tracking-tighter text-3xl md:text-5xl leading-tight">
            Pertanyaan yang sering diajukan.
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="md:col-span-7">
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-[#211B10]/10">
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="text-left font-display text-lg md:text-xl tracking-tight hover:text-[#A67C1E] hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-[#211B10]/60 leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  </>
  );
};
